export default __webpack_public_path__ + "static/media/icon-add-note-circle-outline.8d0fbe6d.svg";